import Vue from 'vue';
import Vuex from 'vuex';

import Accounts from './modules/accounts'
import Admin from './modules/admin'
import RefData  from './modules/referencedata2';
import Patients from './modules/patients'
import Shared   from './modules/shared'
import ReportMortality from './modules/analytics-morbidity'
import GyneForm from './forms/maternal-gyneform-state'
import CaseForm from './forms/case-form-state'
import SectionValidation from './modules/active-form-section-validations'
import Submissions from './modules/submissions'
import Categories from './modules/categories'
import Tables from './modules/analytics-table'


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Accounts,
    Admin,
    Shared,
    RefData,
    GyneForm,
    Patients,
    CaseForm,
    SectionValidation,
    Submissions,
    ReportMortality,
    Categories,
    Tables
  }
});
